import * as walletApi from "api/walletApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchTraitsInWallet = (address?: string) =>
  useFetchPromise<number[], string>(walletApi.fetchWalletTraits, address);

export default useFetchTraitsInWallet;
